/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Csv_To_Json_Faq_A6Inputs */

const en_csv_to_json_faq_a6 = /** @type {(inputs: Csv_To_Json_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes to both. Carriage return and line feed pairs, lone carriage returns, and lone line feeds all end a record, and a newline inside a quoted field stays part of the value because the whole document is scanned rather than split into lines first.`)
};

const ko_csv_to_json_faq_a6 = /** @type {(inputs: Csv_To_Json_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`둘 다 처리합니다. 캐리지 리턴과 라인 피드 쌍, 단독 캐리지 리턴, 단독 라인 피드가 모두 레코드를 끝내며, 문서를 줄로 먼저 쪼개지 않고 전체를 훑기 때문에 인용 필드 안의 줄바꿈은 값의 일부로 남습니다.`)
};

const ja_csv_to_json_faq_a6 = /** @type {(inputs: Csv_To_Json_Faq_A6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`どちらも扱えます。キャリッジリターンとラインフィードの対、単独のキャリッジリターン、単独のラインフィードのいずれもレコードを終わらせ、文書を先に行へ分割せず全体を走査するため、引用フィールド内の改行は値の一部として残ります。`)
};

/**
* | output |
* | --- |
* | "Yes to both. Carriage return and line feed pairs, lone carriage returns, and lone line feeds all end a record, and a newline inside a quoted field stays part..." |
*
* @param {Csv_To_Json_Faq_A6Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const csv_to_json_faq_a6 = /** @type {((inputs?: Csv_To_Json_Faq_A6Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Csv_To_Json_Faq_A6Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_csv_to_json_faq_a6(inputs)
	if (locale === "ko") return ko_csv_to_json_faq_a6(inputs)
	return ja_csv_to_json_faq_a6(inputs)
});